<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan">
          <div class="modal-content p-3 p-md-5">
            <div class="modal-body p-2">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
              <div class="text-center">
                <h3 class="mb-2">{{ reportStore.selectedDataFurnisherData.name}}</h3>
                <p>{{ reportStore.selectedDataFurnisherData.address_name}}</p>
              </div>
              <div id="wizard-create-app" class="bs-stepper vertical mt-2 shadow-none">
                <div class="bs-stepper-content p-1 col-sm-7">
                    <span v-html="reportStore.selectedDataFurnisherData.description"></span>
                </div>
                <div class="bs-stepper-header border-0 p-1 col-sm-5">
                    <h5 style="font-weight: bolder;">Website</h5>

                    <a :href="reportStore.selectedDataFurnisherData.website" class="href" target="_blank">{{reportStore.selectedDataFurnisherData.website}}</a><br>
                    <h5 style="font-weight: bolder;">Phone</h5>

                    {{reportStore.selectedDataFurnisherData.phone_number}}
                    <template v-if="reportStore.selectedDataFurnisherData.phone_number1">
                        or
                        {{reportStore.selectedDataFurnisherData.phone_number1}}
                    </template>
                    <template v-if="reportStore.selectedDataFurnisherData.phone_number2">
                        or
                        {{reportStore.selectedDataFurnisherData.phone_number2}}
                    </template>
                    <br>
                    <h5 style="font-weight: bolder;">Address</h5>
                    {{reportStore.selectedDataFurnisherData.address_name}}<br>
                    {{reportStore.selectedDataFurnisherData.street_address}}<br>
                    {{reportStore.selectedDataFurnisherData.city}}, {{reportStore.selectedDataFurnisherData.state_abbrev}} {{reportStore.selectedDataFurnisherData.zipcode}}

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import { useReportStore } from '../../stores/ReportStore.js'

export default{
    props: {
        id: String
    },
    setup(){
        return{
            reportStore:useReportStore(),
        }
    },

}
</script>
<style>
    .data-furnisher-model-text{
        height: 20px;
        width: 20px;
        background: #4b9a5e;
        border-radius: 100%;
        position: relative;
        margin-right: 5px;
        font-weight: bolder;
    }
    .data-furnisher-model-text .feather-ico{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: white;
    }
</style>
